// @flow
import { css, createGlobalStyle } from 'styled-components';

export const components = css``;

export const Components = createGlobalStyle`${components}`;

export default components;
